/* tslint:disable:max-line-length */
export const L10N_EN = {
  format_date: 'YYYY-MM-DD',
  format_date_placeholder: 'year-month-day',

  validation_required: 'Field {0} is required',
  validation_requiredThis: 'This field is required field',
  validation_email: 'Value of the field {0} is not a valid email.',
  validation_date: 'Value is not a valid date. Valid format is: 1984-02-24 (for Feb 24)',
  validation_captchaRequired: 'Click in the white square please. This check is needed to filter out software robots.',
  validation_captchaInvalid: 'You didn\'t write the text from the picture correctly. Try it again please.',
  validation_duplicateRegistration: 'You are already registered for the selected course. Take a step back and choose another one please.',
  validation_birthdateYear: 'Please enter a valid year of birth',

  app_error_entityValidation: 'Submitted data didn\'t pass the validation.',
  app_error_entityNotFound: 'Requested record was not found.',
  app_error_db_insertFailed: 'Error saving data to a database.',
  app_error_db_updateFailed: 'Error updating data in a database.',
  app_error_db_deleteFailed: 'Error deleting data from a database. It\'s probably referenced from other records.',
  app_error_internalServerError: 'Error processing the request.',

  app_page_title: 'Event registration',

  error_otEventRegistrationDisabled: 'We apologize, but it\'s not possible to register for this event.',
  error_otEventIsFull: 'We apologize, this event is already full and it\'s not possible to register for it anymore.',

  warning: 'Warning',
  error: 'Error',

  menu_otEvents: 'One time events',
  menu_price: 'Price',
  menu_person: 'Person',
  menu_locations: 'Locations',
  menu_summary: 'Summary',
  menu_success: 'Registration created',

  dayOfWeek_0: 'Monday',
  dayOfWeek_1: 'Tuesday',
  dayOfWeek_2: 'Wednesday',
  dayOfWeek_3: 'Thursday',
  dayOfWeek_4: 'Friday',
  dayOfWeek_5: 'Saturday',
  dayOfWeek_6: 'Sunday',

  region_entity: 'Region',

  person_lastName: 'Family name',
  person_firstName: 'Given name',
  person_fullName: 'Name',
  person_birthdate: 'Birthdate',
  person_birthdateYear: 'Birthdate year',
  person_email: 'Email',
  person_telephone: 'Telephone',
  person_street: 'Street and number',
  person_city: 'City',
  person_zipCode: 'Postcode',
  person_country: 'Country',
  person_address: 'Address',

  personAddress_showFields: 'I want to fill my address',
  personAddress_street: 'Street',
  personAddress_city: 'City',
  personAddress_postcode: 'Postcode',
  personAddress_country: 'Country',

  course_dayOfWeek: 'Day',
  course_timeFromTo: 'Time',
  course_courseTags: 'Course type',
  course_description: 'Description',
  course_venue: 'Venue',
  course_room: 'Room',
  course_teacher: 'Teacher',
  course_price: 'Price',
  course_: '',
  course_organization: 'Organization',
  course_timePeriod: 'Time period',

  otEvent_name: 'Name',
  otEvent_startDate: 'Date',
  otEvent_dayOfWeek: 'Day',
  otEvent_timeFromTo: 'Time',
  otEvent_description: 'Description',
  otEvent_venue: 'Venue',
  otEvent_room: 'Room',
  otEvent_teacher: 'Lead by',
  otEvent_organization: 'Organization',

  city_name: 'City',
  city_happeningCount: 'Event count',

  happening_occupancy: 'Occupancy',

  registration_notes: 'Your registration notes',
  registration_informationSourceAnswer: 'Where did you learn about our courses',
  registration_registrationReasonAnswers: 'Your reason of being interested in the course',
  registration_price: 'Registration price',
  registration_discounts: 'Discounts',
  registration_premiums: 'Premiums',
  registration_discountsAndPremiums: 'Discounts and premiums',
  registration_selectedOtEvent: 'Selected event',
  registration_pricingInfo: 'Registration price',
  registration_paymentTypeConfig: 'Payment method',

  registrationReasonAnswer_custom: 'Other reason',
  registrationReasonAnswer_custom_placeholder: 'Please specify your reason',

  button_select: 'Select',
  button_ok: 'OK',

  breadcrumb_city: 'City selection',
  breadcrumb_season: 'Season selection',
  breadcrumb_course: 'Course selection',
  breadcrumb_personalData: 'Personal data',
  breadcrumb_startNewRegistration: 'Create new registration',
  breadcrumb_summary: 'Summary',

  captcha: 'Anti-robot check',
  captcha_invalid: 'Entered check value was invalid',

  organization_paymentNotes: 'Payment information',

  personalData_title: 'Your personal data',
  personalData_info: 'Your personal data will neither be published nor misused in any way. We need them just for record keeping.',
  personalData_currentAddress: 'Correspondence address',
  personalData_agreeWithPersonalDataProcessing: 'I grant consent to the processing of my personal data',
  personalData_personalDataProcessing_required: 'It\'s necessary to express your consent to the processing of your personal data.',
  personalData_personalDataProcessing_label: 'Personal data processing',
  personalData_showAgreement: 'Show full agreement',
  personalData_paymentNotes: 'Payment information',
  personalData_agreeWithTermsAndConditions: 'I agree to terms and conditions',
  personalData_termsAndConditionsConsent_required: 'It\'s necessary to express your consent to the terms and conditions.',
  personalData_showTermsAndConditions: 'Show terms and conditions',
  personalData_goToSummary: 'Proceed to summary',
  personalData_newsSubscriber: 'I wish to get news on my email',
  personalData_firstName_placeholder: 'e.g. Silvia',
  personalData_lastName_placeholder: 'e.g. Peterson',
  personalData_nameFormat_info: 'Please enter your names with correct character size (not all capitals) and without titles',
  personalData_address_info: 'Enter your address if you need on a tax document (e.g. for an insurance company)',
  personalData_paymentRedirect_title: 'Redirection',
  personalData_paymentRedirect_info: 'You are going to be redirected to the payment gateway {0}.',
  personalData_questionsByEmailInfo: 'If you have questions or remarks, please write them to our email {0}',

  summary_paymentType: 'Payment method',
  summary_paymentType_bank: 'bank transfer',
  summary_paymentType_trustPay: 'payment card',
  summary_payment_qrCode_desc: 'You can use your mobile banking application to scan this code and it will pre-fill the payment form with all necessary values.',

  paymentType_bank: 'Bank transfer',
  paymentType_bank_info: 'Payment information will be displayed in the next step as well as sent to the email you can specify below.',
  paymentType_card: 'Payment card (Visa, MasterCard)',
  paymentType_card_info: 'After finishing this registration, you\'ll get to the payment web site.',

  paymentGateway_trustPay: 'TrustPay',

  price_title: 'Price',
  price_socialDiscount: 'Discount for ',
  price_chooseSocialGroup: 'Select your social group please',
  price_validation_chooseSocialGroup: 'For this discount to be applied, it\'s necessary to choose a group',
  price_lateRegDiscountInfo: 'The course is already running, the price has been decreased',
  price_premiums: 'Premium options',
  price_discounts: 'Discounts',
  price_basicPrice: 'Basic price',
  price_totalPrice: 'Total price',
  price_paymentType_title: 'Payment method',
  price_goToPersonInfo: 'Go to personal data',
  price_selectPaymentType: 'Select a payment type please',

  finishing_title: 'Registration completion',
  finishing_serverError: 'Your registration was not created because of a server error. Please try it again later or contact us by email at {0}. We apologize for complications.',

  success_title: 'Registration has been successfully completed',
  success_thanks: 'Thank you for registering for a yoga course',
  success_emailSent: 'The information displayed below will be sent to your email address {0} as well.',
  success_emailSent_spanNotice: 'If you don\'t receive the email, check your spam box as well please.',
  success_emailSendingError: 'There was an error sending a confirmation email with the information below to your address {0}), but your registration is valid. Please write down the payment information displayed on this page.',

  error_title: 'Application error',
  error_generic_desc: 'Pri komunikácii so serverom nastala chyba. Skúste prosím operáciu znovu, alebo nás kontaktujte emailom na adrese {0}. Ospravedlňujeme sa za komplikáciu.',
  error_goTo: 'Go to',
  error_homepage: 'homepage',

  registration_error_creatingPerson: 'Error creating a person record.',
  registration_error_updatingPerson: 'Error updating a person record.',
  registration_error_saving: 'Error saving the registration to a database.',
  registration_error_creating: 'Error creating the registration.',
  registration_error_precedingRegNotFound: 'If you have attended a course in the preceeding season, contact us by email at address {0} please.',
  registration_onlyPrecedingSeasonParticipants: 'For this course season, only participants of course from the preceeding season "{0}" may register. It allows them to attend a subsequent course. Others will be able to register later. Thank you for your understanding.',
  registration_followUpOnly: 'Registration is allowed only for participants of running courses.',
  registration_change: 'change',
  registration_informationSource_customText: 'other source (you can specify it)',
  registration_informationSource_customText_placeholder: 'Please specify your source',

  summary_title: 'Summary',
  summary_registration_number: 'Registration number',
  summary_registration_price: 'Registration price',
  summary_registration_basicPrice: 'Basic course price',

  summary_payment: 'Payment information',
  summary_payment_bank_deadline: 'It\'s necessary to perform the payment till the date days, that was sent to you, otherwise the registration becomes invalid.',
  summary_payment_bank_sendTo: 'Please send your payment to our bank account:',
  summary_payment_bank_bankName: 'Bank name',
  summary_payment_bank_accountNumber: 'Account number',
  summary_payment_bank_iban: 'IBAN',
  summary_payment_bank_variableSymbol: 'Variable symbol',
  summary_payment_bank_specificSymbol: 'Specific symbol',
  summary_payment_notes: 'Payment notes',
  summary_successfullyPayed: 'Your registration has been successfully payed.',

  summary_selectedCourse: 'Selected course',

  result_error_title: 'Error performing payment',
  result_error_info: 'There was an error during your payment. You can try it again or change the payment method or cancel your registration.',

  result_cancel_title: 'Your payment for the registration was cancelled',
  result_cancel_info: 'If you cancelled your payment because of an unsuitable payment method, you can change it below.',

  result_repeatPayment_title: 'Opakovanie pokusu o platbu',
  result_repeatPayment_info: 'If there was a technical error on the payment gateway, it will probably be fixed soon. You can try to perform your payment in a short time again.',
  result_repeatPayment_button: 'Try to pay again',
  result_changePaymentType_title: 'Change registration payment method',
  result_registration_title: 'Your registration',

  result_changePaymentType_button_offline: 'Change payment type',
  result_changePaymentType_button_online: 'Pay by the selected method',
  result_changePaymentType_selectType: 'Please select a new payment method',

  result_cancelRegistration_title: 'Cancel registration',
  result_cancelRegistration_info: 'If you decided not to perform payment for your registration, cancel it please.',
  result_cancelRegistration_button: 'Cancel registration',
  result_cancelRegistration_success: 'Your registration number {0} was cancelled.',

  termsAndConditions_title: 'Terms and conditions',
  termsAndConditions_info: 'Terms and conditions of the organization {0}.',

  organizationPage_title: 'Information about organization',
  organizationPage_basicInfo: 'Basic information',
  organizationPage_places: 'Yoga centers',

  organization_name: 'Name',
  organization_address: 'Address',
  organization_telephone: 'Telephone',
  organization_email: 'Email',
  organization_termsAndConditions: 'Terms and conditions',

  summary_orderButton: 'Submit your order',
  summary_onlinePaymentInfo: 'After submitting your registration, you will be redirected to a payment gateway.',
  summary_submitBlock_title: 'Submit registration',
  summary_afterRegistrationInfo: 'Additional information from organization'
};
